export default __webpack_public_path__ + "static/media/elevate-cbb-poster-3.cb33562b.jpg";